import lax from 'lax.js';

const IS_TOUCH_DEVICE =
  'ontouchstart' in window ||
  navigator.maxTouchPoints > 0 ||
  window.matchMedia('(pointer:coarse)').matches;


const init = () => {

  if (IS_TOUCH_DEVICE) return;

  lax.init();

  document.addEventListener('mousemove', (e) => {
    lax.__cursorX = e.clientX;
    lax.__cursorY = e.clientY;
  }, false);

  lax.addDriver('cursorX', function () {
    return lax.__cursorX || 0;
  });


  lax.addDriver('cursorY', function () {
    return lax.__cursorY || 0;
  });

  lax.addDriver('scrollY', function () {
    return window.scrollY || 0;
  });



  lax.addElements(".js-cloud", {
    'cursorX': {
      "translateX": [
        [0, 'screenWidth'],
        [25, -25],

      ],
    },
    'cursorY': {
      "translateY": [
        [0, 'screenHeight'],
        [15, -15],
      ],
    },
  });

  lax.addElements(".js-cloud-y", {
    'scrollY': {
      translateY: [['elInY', 'elOutY'], [-60, 60]],
    },

  });

};

export default init;